export default function getResource(label) {
    const resources = {
        saveContinueButton: 'Save & Continue'
    };

    return resources[label];
}
